module.exports = __webpack_public_path__ + "static/media/downloadApk.5fb21db1.jpg";